var map = {
	"./acn-logo-colour.png": 85641,
	"./championnat-africain-logo-colour.png": 61473,
	"./chlg-logo-colour.png": 78951,
	"./epl-logo-colour.png": 15218,
	"./euro-logo-colour.png": 67558,
	"./european-championship-2024-logo-colour.png": 85953,
	"./fifa-world-cup-logo-colour.png": 19569,
	"./fran-logo-colour.png": 65996,
	"./french-ligue-1-logo-colour.png": 79886,
	"./la-liga-logo-colour.png": 16788,
	"./liga-logo-colour.png": 15560,
	"./natl-logo-colour.png": 29310,
	"./psl-logo-colour.png": 5838,
	"./safr-logo-colour.png": 6885,
	"./serie-a-logo-colour.png": 38049,
	"./seriea-logo-colour.png": 74264,
	"./uefa-champions-league-logo-colour.png": 11711,
	"./women's-world-cup-logo-colour.png": 13855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55620;